import script from "./MeetingsView.vue?vue&type=script&setup=true&lang=js"
export * from "./MeetingsView.vue?vue&type=script&setup=true&lang=js"

import "./MeetingsView.vue?vue&type=style&index=0&id=0601918b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0601918b"]])

export default __exports__